import {
  AdornedInput,
  Adornment,
  ComboboxOption,
  Flex,
  Input,
  mediaMixin,
  spaceMixin,
  token,
} from '@zillow/constellation';
import styled, { css } from 'styled-components';

const PROPERTY_DROPDOWN_WIDTH = '309px';

export const StyledComboboxOption = styled(ComboboxOption)`
  div {
    white-space: pre;
    color: ${token('colors.textMedium')};
  }

  div::first-line {
    color: ${token('colors.textDark')};
  }
`;

export const StyledAdornedInput = styled(AdornedInput)`
  min-width: ${PROPERTY_DROPDOWN_WIDTH};

  label {
    background-color: ${token('colors.white')};
    padding-left: ${spaceMixin('xs')} !important;
    cursor: pointer;

    & svg {
      fill: ${token('colors.gray500')};
    }
  }
`;

export const StyledInput = styled(Input)`
  background-color: ${token('colors.white')};
`;

export const StyledSkeleton = styled(Flex)`
  min-width: 301px;
  padding: 18px ${spaceMixin('xs')} 18px 0;

  ${mediaMixin(
    'sm_lte',
    css`
      min-width: 165px;
    `,
  )}
`;

export const StyledSkeletonInput = styled(Input)`
  background: ${token('colors.white')} !important;
`;

export const StyledSkeletonAdornment = styled(Adornment)`
  background: ${token('colors.white')} !important;
`;
